import { QueryClientProvider } from '@tanstack/react-query';
import { fullPageRedirect } from '@hungryroot/environment';
import {
  Header,
  PromoBanner,
} from '@hungryroot/exp-159-precheckout-plan-redesign';
import { useExperiment } from '@hungryroot/experiments';
import {
  Breadcrumb,
  FunnelHeader,
  useFunnelRedirects,
} from '@hungryroot/funnel';
import { Cyo, CyoPage } from '@hungryroot/page-cyo';
import { parsePromo, usePromoData } from '@hungryroot/promos';
import { MY_HUNGRYROOT_ROUTE } from '@hungryroot/routes';
import { Utm } from '@hungryroot/segment';
import { client } from '../../components/rest/react-query';
import { renderApp } from '../../frontend/react/src/utils/utils';
import styles from './limited_time.module.css';

function onSaveAndExitClick() {
  fullPageRedirect(MY_HUNGRYROOT_ROUTE);
}

const CyoPageWrapper = () => {
  const funnelRedirects = useFunnelRedirects();

  const exp159 = useExperiment(159);
  const inExp159Variant = exp159 !== undefined && exp159 > 0;

  const promoData = usePromoData({ page: '/limited-time/' });

  if (!funnelRedirects) {
    return null;
  }

  if (exp159 === undefined) {
    return null;
  }

  const { afterCyo, beforeCyo } = funnelRedirects;

  const { data } = promoData;
  const parsed = data === undefined ? undefined : parsePromo(data);

  return (
    <>
      <Cyo
        header={
          inExp159Variant ? (
            <Header
              children={
                parsed && (
                  <PromoBanner
                    promoText={`${parsed.parts
                      .map((part) => {
                        return part.text;
                      })
                      .join(' ')}`}
                  />
                )
              }
              onBackButtonClick={() => {
                fullPageRedirect(beforeCyo);
              }}
            />
          ) : (
            <FunnelHeader
              saveAndExitButtonText="Save and exit"
              onSaveAndExitClick={onSaveAndExitClick}
            >
              <Breadcrumb selected="Claim Offer" />
            </FunnelHeader>
          )
        }
        showPromo={!inExp159Variant}
      />
      <CyoPage
        backCyoPath={inExp159Variant ? undefined : beforeCyo}
        onCustomerUpdated={() => {
          fullPageRedirect(afterCyo);
        }}
        selectCyoPath={afterCyo}
        headerClassName={inExp159Variant ? styles.header : undefined}
      />
    </>
  );
};

if (document.getElementById('limited-time-page') !== null) {
  renderApp(
    <QueryClientProvider client={client}>
      <Utm search={window.location.search} />
      <CyoPageWrapper />
    </QueryClientProvider>,
    'container'
  );
}
